import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Field } from 'redux-form'

export const SmsCode = ({ index, onClick }) => {
  const { t } = useTranslation('common')

  return (
    <div className='sms-potvrda'>
      <Field
        id={`code-${index}`}
        name={`phones[${index}].code`}
        placeholder={t('UNESITE KOD')}
        className='unesi-kod-input'
        component='input'
      />
      <button className='potvrdi-btn' type='button' data-id={index} onClick={onClick}>
        {t('Potvrdi')}
      </button>
    </div>
  )
}

SmsCode.propTypes = {
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
}

SmsCode.defaultProps = {
  index: 0
}
